import { CommonModule } from "@angular/common";
import { Component, Input } from "@angular/core";
import { HeaderComponent } from "../../components/header/header.component";
import { LeftSectionComponent } from "../../components/left-section/left-section.component";
import { DynamicComponentDirective } from "src/directives/dynamic-component.directive";

@Component({
  standalone: true,
  imports: [CommonModule, DynamicComponentDirective, HeaderComponent, LeftSectionComponent],
  selector: "app-2-col-layout",
  templateUrl: "./2-col.layout.html",
  styleUrls: ["./2-col.layout.scss"],
})
export class App2ColLayout {
  protected headerSection = HeaderComponent;
  protected headerSectionInstanceData = null;
  protected leftSection = LeftSectionComponent;
  protected leftSectionInstanceData = null;
}
